import { Cookies } from "react-cookie";

const cookies = new Cookies();
interface CookieSetOptions {
  path?: string;
  expires?: Date;
  maxAge?: number;
  domain?: string;
  secure?: boolean;
  httpOnly?: boolean;
  sameSite?: boolean | "none" | "lax" | "strict";
}
interface CookieChangeOptions {
  name: string;
  value?: any;
  options?: CookieSetOptions;
}
export const setCookie = ({ name, value, options }: CookieChangeOptions) => {
  return cookies.set(name, value, { ...options });
};

export const getCookie = ({ name }: { name: string }) => {
  return cookies.get(name);
};
